import { API_BASE_URL } from './index';
import { getToken, getUser } from './auth';

export const loansUnderAlertApi = {
  getLoansUnderAlert: async () => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/loans-under-alert`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to load loans under alert' }));
      throw new Error(error.error || 'Failed to load loans under alert');
    }

    return response.json();
  },
};
